import React, { useState, useEffect, useRef } from 'react';
import { AZUL, LARANJA, VERDE, CINZA, VERDE_WPP } from '../styles/colors';
import { db, logoutUsuario, buscarPerfil } from '../firebase';
import { collection, query, where, getDocs, onSnapshot } from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

const STATUS_COR = {
  pendente:    { label: 'Aguardando', cor: '#f59e0b', bg: '#fffbeb' },
  confirmado:  { label: 'Confirmado', cor: '#3b82f6', bg: '#eff6ff' },
  em_entrega:  { label: 'Em entrega', cor: '#8b5cf6', bg: '#f5f3ff' },
  entregue:    { label: 'Entregue',   cor: '#16a34a', bg: '#f0fdf4' },
};

function PainelVendedor({ onNavegar, onLogout }) {
  const [abaAtiva,       setAbaAtiva]       = useState('resumo');
  const [copiado,        setCopiado]        = useState(false);
  const [vendedor,       setVendedor]       = useState(null);
  const [pedidos,        setPedidos]        = useState([]);
  const [clientes,       setClientes]       = useState([]);
  const [loading,        setLoading]        = useState(true);
  const [novoPedido,     setNovoPedido]     = useState(false);
  const [qtdNovos,       setQtdNovos]       = useState(0);
  const pedidosRef       = useRef([]);
  const primeiraVez      = useRef(true);

  // States do modal de cadastro
  const [modalCadastro,  setModalCadastro]  = useState(false);
  const [cadNome,        setCadNome]        = useState('');
  const [cadEmail,       setCadEmail]       = useState('');
  const [cadCnpj,        setCadCnpj]        = useState('');
  const [cadTelefone,    setCadTelefone]    = useState('');
  const [cadRazao,       setCadRazao]       = useState('');
  const [cadErro,        setCadErro]        = useState('');
  const [cadSucesso,     setCadSucesso]     = useState('');
  const [cadCarregando,  setCadCarregando]  = useState(false);

  useEffect(() => {
    iniciar();
    return () => {};
  }, []);

  async function iniciar() {
    setLoading(true);
    try {
      const perfil = JSON.parse(localStorage.getItem('perfil') || 'null');
      if (!perfil?.uid) { setLoading(false); return; }

      const dadosVendedor = await buscarPerfil(perfil.uid);
      setVendedor(dadosVendedor);

      const qClientes = query(
        collection(db, 'usuarios'),
        where('vendedorId', '==', perfil.uid),
        where('perfil', '==', 'cliente')
      );
      const snapClientes = await getDocs(qClientes);
      setClientes(snapClientes.docs.map(d => ({ id: d.id, ...d.data() })));

      const ids = [perfil.uid];
      const snapVend = await getDocs(query(collection(db, 'usuarios'), where('perfil', '==', 'vendedor')));
      snapVend.docs.forEach(d => {
        if (d.data().uid === perfil.uid && !ids.includes(d.id)) ids.push(d.id);
      });

      ids.forEach(vid => {
        const qPedidos = query(collection(db, 'pedidos'), where('vendedorId', '==', vid));
        onSnapshot(qPedidos, (snap) => {
          const snapIds = snap.docs.map(d => d.id);
          setPedidos(prev => {
            const semEsteVid = prev.filter(p => !snapIds.includes(p.id) && p._vid !== vid);
            const lista = [
              ...semEsteVid,
              ...snap.docs.map(d => ({ id: d.id, _vid: vid, ...d.data() }))
            ];
            lista.sort((a, b) => (b.criadoEm?.seconds || 0) - (a.criadoEm?.seconds || 0));

            if (!primeiraVez.current) {
              const idsAntigos = pedidosRef.current.map(p => p.id);
              const novos = lista.filter(p => !idsAntigos.includes(p.id));
              if (novos.length > 0) {
                setNovoPedido(true);
                setQtdNovos(novos.length);
                try {
                  const ctx = new (window.AudioContext || window.webkitAudioContext)();
                  const osc = ctx.createOscillator();
                  const gain = ctx.createGain();
                  osc.connect(gain);
                  gain.connect(ctx.destination);
                  osc.frequency.value = 880;
                  gain.gain.setValueAtTime(0.3, ctx.currentTime);
                  gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
                  osc.start(ctx.currentTime);
                  osc.stop(ctx.currentTime + 0.5);
                } catch (e) {}
              }
            }

            pedidosRef.current = lista;
            primeiraVez.current = false;
            setLoading(false);
            return lista;
          });
        });
      });

    } catch (e) {
      console.error('Erro ao carregar dados:', e);
      setLoading(false);
    }
  }

  function fecharAlerta() {
    setNovoPedido(false);
    setQtdNovos(0);
    setAbaAtiva('pedidos');
  }

  async function handleLogout() {
    try {
      await logoutUsuario();
      localStorage.removeItem('perfil');
      onLogout();
    } catch (e) {
      console.error('Erro ao sair:', e);
    }
  }

  function formatarData(timestamp) {
    if (!timestamp?.seconds) return '—';
    return new Date(timestamp.seconds * 1000).toLocaleDateString('pt-BR');
  }

  function formatarTotal(total) {
    return Number(total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function gerarSenha(nome) {
    const letras = nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z]/g, '').toLowerCase().slice(0, 6);
    return 'inove@' + letras;
  }

  function abrirModalCadastro() {
    setCadNome(''); setCadEmail(''); setCadCnpj('');
    setCadTelefone(''); setCadRazao(''); setCadErro(''); setCadSucesso('');
    setModalCadastro(true);
  }

  async function handleCadastrarCliente() {
    setCadErro(''); setCadSucesso('');
    if (!cadNome.trim() || !cadEmail.trim()) {
      setCadErro('Nome e e-mail são obrigatórios.');
      return;
    }
    setCadCarregando(true);
    try {
      const perfil = JSON.parse(localStorage.getItem('perfil') || 'null');
      const senha = gerarSenha(cadNome.trim());
      const auth = getAuth();

      const cred = await createUserWithEmailAndPassword(auth, cadEmail.trim(), senha);
      const uid = cred.user.uid;

      await setDoc(doc(db, 'usuarios', uid), {
        uid,
        nome: cadNome.trim(),
        razaoSocial: cadRazao.trim() || cadNome.trim(),
        email: cadEmail.trim(),
        cnpj: cadCnpj.trim(),
        telefone: cadTelefone.trim(),
        perfil: 'cliente',
        vendedorId: perfil.uid,
        criadoEm: new Date(),
      });

      // Recarrega lista de clientes
      const qClientes = query(
        collection(db, 'usuarios'),
        where('vendedorId', '==', perfil.uid),
        where('perfil', '==', 'cliente')
      );
      const snapClientes = await getDocs(qClientes);
      setClientes(snapClientes.docs.map(d => ({ id: d.id, ...d.data() })));

      setCadSucesso(`Cliente cadastrado! Senha: ${senha}`);
      setCadCarregando(false);
    } catch (e) {
      console.error(e);
      if (e.code === 'auth/email-already-in-use') {
        setCadErro('Este e-mail já está cadastrado.');
      } else {
        setCadErro('Erro ao cadastrar. Tente novamente.');
      }
      setCadCarregando(false);
    }
  }

  const totalVendas      = pedidos.reduce((acc, p) => acc + (Number(p.total) || 0), 0);
  const pedidosMes       = pedidos.length;
  const comissaoMes      = totalVendas * ((vendedor?.comissao || 5) / 100);
  const pedidosPendentes = pedidos.filter(p => p.status === 'pendente');

  const link = vendedor
    ? `https://inove-app-53fa7.web.app?ref=${vendedor.linkPersonalizado}`
    : 'Carregando...';

  function handleCopiarLink() {
    navigator.clipboard.writeText(link).then(() => {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    });
  }

  function handleWhatsAppLink() {
    const msg = `Olá! Acesse o catálogo exclusivo da Apoio Materiais Elétricos pelo link: ${link}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
  }

  function handleContatarCliente(cliente) {
    const tel = '55' + (cliente.telefone || '').replace(/\D/g, '');
    window.open(`https://wa.me/${tel}`, '_blank');
  }

  const iniciais = vendedor?.nome?.split(' ').map(n => n[0]).slice(0, 2).join('') || '??';

  if (loading) {
    return (
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: CINZA }}>
        <div style={{ textAlign: 'center', color: '#aaa' }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>⏳</div>
          <div style={{ fontSize: 13 }}>Carregando painel...</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: CINZA, position: 'relative' }}>

      {/* Modal Cadastrar Cliente */}
      {modalCadastro && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 1000,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: 20,
        }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: '100%', maxWidth: 400 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a', marginBottom: 16 }}>
              👤 Cadastrar Novo Cliente
            </div>

            {['Nome completo *', 'E-mail *', 'Razão Social', 'CNPJ', 'Telefone'].map((label, i) => {
              const vals  = [cadNome, cadEmail, cadRazao, cadCnpj, cadTelefone];
              const setters = [setCadNome, setCadEmail, setCadRazao, setCadCnpj, setCadTelefone];
              return (
                <div key={label} style={{ marginBottom: 10 }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{label}</div>
                  <input
                    value={vals[i]}
                    onChange={e => setters[i](e.target.value)}
                    style={{ width: '100%', border: '1px solid #ddd', borderRadius: 8, padding: '8px 10px', fontSize: 13, boxSizing: 'border-box' }}
                  />
                </div>
              );
            })}

            {cadNome && (
              <div style={{ fontSize: 11, color: '#888', marginBottom: 10, background: '#f4f4f2', borderRadius: 8, padding: '6px 10px' }}>
                🔑 Senha gerada: <strong>{gerarSenha(cadNome)}</strong>
              </div>
            )}

            {cadErro && <div style={{ fontSize: 12, color: '#dc2626', marginBottom: 10 }}>{cadErro}</div>}
            {cadSucesso && <div style={{ fontSize: 12, color: '#16a34a', marginBottom: 10, fontWeight: 600 }}>{cadSucesso}</div>}

            <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
              <button onClick={() => setModalCadastro(false)}
                style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 12, fontSize: 13, fontWeight: 600, cursor: 'pointer', color: '#555' }}>
                Fechar
              </button>
              {!cadSucesso && (
                <button onClick={handleCadastrarCliente} disabled={cadCarregando}
                  style={{ flex: 2, background: AZUL, border: 'none', borderRadius: 10, padding: 12, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', opacity: cadCarregando ? 0.7 : 1 }}>
                  {cadCarregando ? 'Cadastrando...' : 'Cadastrar'}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Alerta novo pedido */}
      {novoPedido && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, zIndex: 200,
          background: 'linear-gradient(135deg, #16a34a, #15803d)',
          padding: '12px 16px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 24 }}>🔔</span>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>
                {qtdNovos === 1 ? 'Novo pedido recebido!' : `${qtdNovos} novos pedidos!`}
              </div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.8)' }}>Toque para ver</div>
            </div>
          </div>
          <button onClick={fecharAlerta}
            style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>
            Ver →
          </button>
        </div>
      )}

      {/* Header */}
      <div style={{ background: AZUL, padding: '14px 18px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 38, height: 38, borderRadius: '50%', background: LARANJA, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: '#fff' }}>
              {iniciais}
            </div>
            <div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.6)' }}>Painel do Vendedor</div>
              <div style={{ fontSize: 15, fontWeight: 600, color: '#fff' }}>{vendedor?.nome || '...'}</div>
              <div onClick={() => onNavegar('home')}
                style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', cursor: 'pointer', marginTop: 2 }}>
                ← Voltar ao início
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {pedidosPendentes.length > 0 && (
              <div onClick={() => setAbaAtiva('pedidos')}
                style={{ background: '#ef4444', borderRadius: '50%', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#fff', cursor: 'pointer' }}>
                {pedidosPendentes.length}
              </div>
            )}
            <button onClick={handleLogout}
              style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, padding: '6px 10px', fontSize: 11, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>
              Sair
            </button>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 6 }}>
          {[
            { id: 'resumo',   label: '📊 Resumo'   },
            { id: 'pedidos',  label: `📋 Pedidos${pedidos.length > 0 ? ` (${pedidos.length})` : ''}` },
            { id: 'clientes', label: `👥 Clientes${clientes.length > 0 ? ` (${clientes.length})` : ''}` },
            { id: 'link',     label: '🔗 Meu Link' },
          ].map(aba => (
            <button key={aba.id} onClick={() => setAbaAtiva(aba.id)}
              style={{ flex: 1, background: abaAtiva === aba.id ? '#fff' : 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 8, padding: '7px 4px', fontSize: 10, fontWeight: 600, color: abaAtiva === aba.id ? AZUL : 'rgba(255,255,255,0.7)', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              {aba.label}
            </button>
          ))}
        </div>
      </div>

      {/* Conteúdo */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '14px 12px 0' }}>

        {abaAtiva === 'resumo' && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 14 }}>
              {[
                { label: 'Total de Vendas', valor: formatarTotal(totalVendas), emoji: '💰', cor: AZUL    },
                { label: 'Pedidos no Mês',  valor: String(pedidosMes),          emoji: '📋', cor: VERDE   },
                { label: 'Comissão do Mês', valor: formatarTotal(comissaoMes),  emoji: '🏅', cor: LARANJA },
              ].map(ind => (
                <div key={ind.label} style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '10px 8px', textAlign: 'center' }}>
                  <div style={{ fontSize: 20, marginBottom: 4 }}>{ind.emoji}</div>
                  <div style={{ fontSize: 12, fontWeight: 800, color: ind.cor }}>{ind.valor}</div>
                  <div style={{ fontSize: 9, color: '#aaa', marginTop: 2, lineHeight: 1.3 }}>{ind.label}</div>
                </div>
              ))}
            </div>

            <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px', marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a' }}>Pedidos Pendentes</span>
                <span onClick={() => setAbaAtiva('pedidos')} style={{ fontSize: 11, color: AZUL, fontWeight: 500, cursor: 'pointer' }}>Ver todos</span>
              </div>
              {pedidosPendentes.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '12px 0', color: '#aaa', fontSize: 12 }}>Nenhum pedido pendente</div>
              ) : (
                pedidosPendentes.slice(0, 2).map(p => {
                  const st = STATUS_COR[p.status] || STATUS_COR['pendente'];
                  return (
                    <div key={p.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f4f4f2' }}>
                      <div>
                        <div style={{ fontSize: 11, fontWeight: 600, color: '#1a1a1a' }}>{p.clienteRazaoSocial || p.clienteNome}</div>
                        <div style={{ fontSize: 10, color: '#aaa', marginTop: 1 }}>#{p.id.slice(-6).toUpperCase()} · {formatarData(p.criadoEm)}</div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: AZUL }}>{formatarTotal(p.total)}</div>
                        <div style={{ background: st.bg, borderRadius: 10, padding: '2px 7px', fontSize: 9, fontWeight: 700, color: st.cor, marginTop: 3 }}>{st.label}</div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px', marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a' }}>Meus Clientes</span>
                <span onClick={() => setAbaAtiva('clientes')} style={{ fontSize: 11, color: AZUL, fontWeight: 500, cursor: 'pointer' }}>Ver todos</span>
              </div>
              {clientes.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '12px 0', color: '#aaa', fontSize: 12 }}>Nenhum cliente vinculado ainda</div>
              ) : (
                clientes.slice(0, 3).map(c => (
                  <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 0', borderBottom: '1px solid #f4f4f2' }}>
                    <div style={{ width: 30, height: 30, borderRadius: '50%', background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: AZUL, flexShrink: 0 }}>
                      {(c.razaoSocial || c.nome)?.split(' ').map(n => n[0]).slice(0, 2).join('')}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 12, fontWeight: 500, color: '#1a1a1a' }}>{c.razaoSocial || c.nome}</div>
                      <div style={{ fontSize: 10, color: '#aaa' }}>{c.endereco?.cidade || '—'}</div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </>
        )}

        {abaAtiva === 'pedidos' && (
          <>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#888', marginBottom: 10 }}>
              {pedidos.length} {pedidos.length === 1 ? 'pedido' : 'pedidos'} no total
            </div>
            {pedidos.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#aaa', fontSize: 13 }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
                Nenhum pedido ainda
              </div>
            ) : (
              pedidos.map(p => {
                const st = STATUS_COR[p.status] || STATUS_COR['pendente'];
                return (
                  <div key={p.id} style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '12px 14px', marginBottom: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                      <div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1a1a' }}>{p.clienteRazaoSocial || p.clienteNome}</div>
                        <div style={{ fontSize: 10, color: '#aaa', marginTop: 1 }}>#{p.id.slice(-6).toUpperCase()} · {formatarData(p.criadoEm)}</div>
                      </div>
                      <div style={{ background: st.bg, borderRadius: 10, padding: '3px 10px', fontSize: 10, fontWeight: 700, color: st.cor }}>{st.label}</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>
                        <span style={{ fontSize: 15, fontWeight: 700, color: AZUL }}>{formatarTotal(p.total)}</span>
                        <span style={{ fontSize: 10, color: '#aaa', marginLeft: 8 }}>{p.itens?.length || 0} produtos</span>
                      </div>
                      {p.pagamento && (
                        <span style={{ fontSize: 10, color: '#888', background: '#f4f4f2', borderRadius: 6, padding: '2px 8px' }}>{p.pagamento}</span>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </>
        )}

        {abaAtiva === 'clientes' && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#888' }}>
                {clientes.length} {clientes.length === 1 ? 'cliente vinculado' : 'clientes vinculados'}
              </div>
              <button onClick={abrirModalCadastro}
                style={{ background: AZUL, border: 'none', borderRadius: 8, padding: '7px 12px', fontSize: 11, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>
                + Cadastrar Novo Cliente
              </button>
            </div>
            {clientes.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#aaa', fontSize: 13 }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>👥</div>
                Nenhum cliente vinculado ainda.
                <div style={{ fontSize: 12, marginTop: 8 }}>Compartilhe seu link para vincular clientes!</div>
              </div>
            ) : (
              clientes.map(c => (
                <div key={c.id} style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '12px 14px', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: AZUL, flexShrink: 0 }}>
                    {c.nome?.split(' ').map(n => n[0]).slice(0, 2).join('')}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a' }}>{c.razaoSocial || c.nome}</div>
                    <div style={{ fontSize: 11, color: '#888', marginTop: 1 }}>{c.nome}</div>
                    <div style={{ fontSize: 11, color: '#aaa', marginTop: 1 }}>{c.cnpj || '—'}</div>
                    <div style={{ fontSize: 10, color: '#bbb', marginTop: 2 }}>{c.endereco?.cidade || ''}{c.endereco?.estado ? `/${c.endereco.estado}` : ''}</div>
                  </div>
                  <button onClick={() => handleContatarCliente(c)}
                    style={{ background: VERDE_WPP, border: 'none', borderRadius: 8, padding: '6px 10px', fontSize: 11, color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
                    💬
                  </button>
                </div>
              ))
            )}
          </>
        )}

        {abaAtiva === 'link' && (
          <>
            <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '16px', marginBottom: 12 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 6 }}>🔗 Seu Link Personalizado</div>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 14, lineHeight: 1.5 }}>
                Compartilhe este link com seus clientes. Quando eles fizerem um pedido, a comissão será associada automaticamente a você.
              </div>
              <div style={{ background: '#f4f4f2', borderRadius: 10, padding: '12px 14px', marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                <span style={{ fontSize: 11, color: AZUL, fontWeight: 600, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{link}</span>
                <button onClick={handleCopiarLink}
                  style={{ background: copiado ? VERDE : AZUL, border: 'none', borderRadius: 7, padding: '6px 12px', fontSize: 11, color: '#fff', fontWeight: 600, cursor: 'pointer', flexShrink: 0 }}>
                  {copiado ? '✔ Copiado!' : 'Copiar'}
                </button>
              </div>
              <button onClick={handleWhatsAppLink}
                style={{ width: '100%', background: VERDE_WPP, border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                <span style={{ fontSize: 16 }}>💬</span>
                Compartilhar pelo WhatsApp
              </button>
            </div>

            <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '16px', marginBottom: 12 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 12 }}>💰 Minha Comissão</div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 13, color: '#555' }}>Taxa de comissão</span>
                <span style={{ fontSize: 20, fontWeight: 800, color: AZUL }}>{vendedor?.comissao || 5}%</span>
              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '16px', marginBottom: 14 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 12 }}>Como funciona?</div>
              {[
                { num: '1', texto: 'Você compartilha seu link pelo WhatsApp com o cliente' },
                { num: '2', texto: 'O cliente acessa o catálogo e faz o cadastro pelo seu link' },
                { num: '3', texto: 'A cada pedido, a comissão é associada automaticamente a você' },
                { num: '4', texto: 'Acompanhe suas comissões aqui no painel' },
              ].map(item => (
                <div key={item.num} style={{ display: 'flex', gap: 12, marginBottom: 10, alignItems: 'flex-start' }}>
                  <div style={{ width: 22, height: 22, borderRadius: '50%', background: AZUL, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#fff', flexShrink: 0 }}>{item.num}</div>
                  <span style={{ fontSize: 12, color: '#555', lineHeight: 1.5 }}>{item.texto}</span>
                </div>
              ))}
            </div>
          </>
        )}

        <div style={{ height: 12 }} />
      </div>

      {/* Bottom Nav */}
      <div style={{ background: '#fff', borderTop: '1px solid #e8e8e5', display: 'flex' }}>
        {[
          { id: 'resumo',   emoji: '📊', label: 'Resumo'   },
          { id: 'pedidos',  emoji: '📋', label: 'Pedidos'  },
          { id: 'clientes', emoji: '👥', label: 'Clientes' },
          { id: 'link',     emoji: '🔗', label: 'Meu Link' },
        ].map(item => (
          <div key={item.id} onClick={() => setAbaAtiva(item.id)}
            style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px 4px 6px', cursor: 'pointer', gap: 3 }}>
            <span style={{ fontSize: 18 }}>{item.emoji}</span>
            <span style={{ fontSize: 9, color: abaAtiva === item.id ? AZUL : '#bbb', fontWeight: abaAtiva === item.id ? 600 : 400 }}>{item.label}</span>
          </div>
        ))}
      </div>

    </div>
  );
}

export default PainelVendedor;